var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardSwipe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_card-pos",
    "data-name": "vuesax/bulk/card-pos",
    transform: "translate(-428 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-pos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.25,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h18.5A.755.755,0,0,1,20,.75.755.755,0,0,1,19.25,1.5Z",
    transform: "translate(430 528.5)",
    fill: "#020d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.96,9.73,9.73,16.96a3.618,3.618,0,0,1-5.12.01L0,12.36,12.36,0l4.61,4.61A3.618,3.618,0,0,1,16.96,9.73Z",
    transform: "translate(431.63 511.97)",
    fill: "#020d88",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 508)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M14.336,1.966,1.966,14.326l-.91-.91a3.618,3.618,0,0,1,.01-5.12L8.3,1.066a3.618,3.618,0,0,1,5.12-.01Z",
    transform: "translate(429.654 510.004)",
    fill: "#020d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.57,1.22,1.22,2.57A.714.714,0,0,1,.21,1.56L1.56.21A.714.714,0,0,1,2.57,1.22Z",
    transform: "translate(438.32 524.38)",
    fill: "#020d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M3.91,1.22,1.22,3.91A.714.714,0,0,1,.21,2.9L2.9.21a.712.712,0,0,1,1.01,0A.731.731,0,0,1,3.91,1.22Z",
    transform: "translate(441.36 520)",
    fill: "#020d88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSwipe);
export default __webpack_public_path__ + "static/media/cardSwipe.a81948dea23c09f13bd158a949ba3515.svg";
export { ForwardRef as ReactComponent };